import { AiModelsCatalogModel, type AiModelsCatalogResponse } from '@/domain/models/ai-model.js';
import type { HttpClient } from '@/domain/protocols/http-client.js';
import type { AiModelsRepository } from '@/domain/repositories/ai-models-repository.js';

export class AiModelsRepositoryImpl implements AiModelsRepository {
    constructor(private readonly httpClient: HttpClient) {}

    public async listModels(): Promise<AiModelsCatalogModel> {
        const response = await this.httpClient.request<AiModelsCatalogResponse>({ url: '/api/ai-models', method: 'GET' });
        return AiModelsCatalogModel.withFromResponse(response.body);
    }
}
